import React from "react";

const Button = ({
  onClick,
  id,
  name,
  label,
  px = "3",
  disabled = false,
  spinnerVisible,
}) => {
  return (
    <button
      id={id}
      name={name}
      onClick={onClick}
      disabled={disabled}
      className={`font-lato  px-[3rem] py-[0.625rem] 
      text-center border-2 border-solid bg-secondary-color
       border-secondary-color transition-all text-white
        hover:bg-[#043b48] hover:border-[#043b48] 
         ease-in-out duration-200 active:bg-secondary-color
          active:border-secondary-color rounded-[0.675rem] `}
    >
      {label}
    </button>
  );
};

export default Button;
